<template>
  <div class="panel panel-default panel-dashboard">
    <loading-spinner v-if="loading"/>

    <div v-else class="panel-body">
      <canvas width="800" height="250"/>
    </div>

    <AchievementsModal :competition="competition" :competition-team-id="competitionTeamId" :date="date"/>
  </div>
</template>

<script>
import datalabels from 'chartjs-plugin-datalabels'
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import Chart from 'chart.js'
import AchievementsModal from './AchievementsModal'

export default {
  components: {AchievementsModal, LoadingSpinner},

  props: {
    competition: {
      required: true
    },

    competitionTeamId: {
      required: true
    }
  },

  data() {
    return {
      intervals: null,

      date: null,

      chart: null,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    competitionTeamId() {
      this.load()
    }
  },

  computed: {
    datasets() {
      let datasets = []

      if (this.competition.attributes.has_progress) {
        datasets.push({
          label: 'Target',
          data: this.intervals.map(interval => interval.attributes.progress.target),
          backgroundColor: '#8da3a6',
          borderColor: '#8da3a6',
          fill: false,
          yAxisID: 'value',
          type: 'line'
        })
      }

      datasets.push({
        label: 'Score',
        data: this.intervals.map(interval => interval.attributes.score),
        backgroundColor: '#eec300',
        borderColor: '#eec300',
        fill: false,
        yAxisID: 'score',
        type: 'bar'
      })

      if (this.competition.attributes.has_progress) {
        datasets.push({
          label: 'Value',
          data: this.intervals.map(interval => interval.attributes.progress.value),
          backgroundColor: '#62d26f',
          borderColor: '#62d26f',
          fill: false,
          yAxisID: 'value',
          type: 'bar'
        })
      }

      return datasets
    },

    yAxes() {
      let yAxes = [{
        id: 'score',
        type: 'linear',
        position: 'left',
        ticks: {
          beginAtZero: true,
          callback: label => this.getFormattedScore(label)
        }
      }]

      if (this.competition.attributes.has_progress) {
        yAxes.push({
          id: 'value',
          type: 'linear',
          position: 'right',
          ticks: {
            beginAtZero: true,
            callback: label => this.getFormattedValue(label)
          },
          gridLines: {
            display: false
          }
        })
      }

      return yAxes
    }
  },

  methods: {
    load() {
      http.get('/api/v2/competition-teams/' + this.competitionTeamId + '/intervals')
          .then(response => {
            this.intervals = response.data.data

            this.loading = false

            this.$nextTick(this.draw)
          })
    },

    draw() {
      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
        plugins: [datalabels],

        type: 'bar',

        data: {
          labels: this.intervals.map(interval => interval.attributes.date),
          datasets: this.datasets
        },

        options: {
          scales: {
            yAxes: this.yAxes
          },

          layout: {
            padding: {
              top: 25
            }
          },

          legend: {
            position: 'bottom'
          },

          plugins: {
            datalabels: {
              display: false
            }
          },

          tooltips: {
            callbacks: {
              label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + (d.datasets[t.datasetIndex].yAxisID === 'score' ? this.getFormattedScore(d.datasets[t.datasetIndex].data[t.index]) : this.getFormattedValue(d.datasets[t.datasetIndex].data[t.index]))
            }
          },

          onClick: event => {
            if (this.chart.getElementAtEvent(event).length) {
              this.date = this.intervals[this.chart.getElementAtEvent(event)[0]._index].attributes.date

              $('#competition-achievements-modal').modal('show')
            }
          }
        }
      })
    },

    getFormattedScore(value) {
      if (this.competition.attributes.score_unit === 'number') {
        return this.$options.filters.number(value)
      }

      if (this.competition.attributes.score_unit === 'money') {
        return this.$options.filters.price(value)
      }

      if (this.competition.attributes.score_unit === 'stars') {
        return '⭐' + value
      }

      return value
    },

    getFormattedValue(value) {
      if (this.competition.attributes.value_unit === 'number') {
        return this.$options.filters.number(value)
      }

      if (this.competition.attributes.value_unit === 'money') {
        return this.$options.filters.price(value)
      }

      return value
    }
  }
}
</script>